module.exports = __webpack_public_path__ + "img/IMG_8906.0f3fef4a.jpg";